/**
 * HE.PasswordRequirements
 */

(function PasswordRequirements($, HE)
{
	"use strict";

	var PasswordRequirements = {};

	// where they are typing in the pw
	var $password_input      = $('.monitor-password-changes');

	// password guidelines bullet points
	// var $password_guidelines = $(".password-requirements ul").find("li");

	// element showing Weak, Medium, Strong indicator
	var $password_meter      = $("#password_meter");

	// button used to save the pw. We want to enable/disable based on pw strength
	var $button              = $(".save-password");

	PasswordRequirements.strengthLevels = {
		weak  : "<span class='alert alert-danger'><small>Password is Weak</small></span>",
		medium: "<span class='alert alert-warning'><small>Password is Medium Strength</small></span>",
		strong: "<span class='alert alert-success'><small>Password is Strong</small></span>"
	};

	// show success or error for every guideline item listed
	PasswordRequirements.applyGuidelinesUi = function applyGuidelinesUi(errors)
	{
		$(".password-requirements ul").find("li").each(function matchError(e)
		{
			var item = $(this);

			if ($.inArray(item.attr('id'), errors) === -1) {
				PasswordRequirements.guidelineItemError(item);
			} else {
				PasswordRequirements.guidelineItemSuccess(item);
			}
		});
	};

	// adjust meter according to strength of pw
	PasswordRequirements.applyMeterUi = function applyMeterUi(strength)
	{
		var lower = strength.toLowerCase();

		$password_meter.removeClass();
		$password_meter.html(this.strengthLevels[lower]);
		$password_meter.addClass(lower);
	};

	// apply all UI changes according to the strength of the potential pw
	PasswordRequirements.applyUi = function applyUi(strength_results)
	{
		this.applyMeterUi(strength_results.strength);
		this.applyGuidelinesUi(strength_results.errors);

		// toggle button
		if (strength_results.strength === 'Strong') {

			$button.removeClass('disabled');
			$button.prop("disabled", false);
		} else {
			$button.addClass('disabled');
			$button.prop("disabled", true);
		}
	};

	// guideline not being met. emphasize in UI
	PasswordRequirements.guidelineItemError = function guidelineItemError($el)
	{
		$el.removeClass("text-bold");
		$el.removeClass("text-danger");
		$el.addClass("text-success");
		$el.find("i").removeClass("hidden"); // show checkmark
	};

	// guideline is met, de-emphasize in UI
	PasswordRequirements.guidelineItemSuccess = function guidelineItemSuccess($el)
	{
		$el.addClass("text-bold");
		$el.removeClass("text-success");
		$el.addClass("text-danger");
		$el.find("i").addClass("hidden"); // hide checkmark
	};

	// test the strength of a string that a user is attempting to make a password
	// uses same logic as ValidationComponent->_password()
	//
	// errors keys match up with ids within HE\templates\elements\PasswordRequirementsElement.php
	PasswordRequirements.testStrength = function testStrength(str)
	{
		var errors      = [],
			responseObj = {strength: "Weak"},
			score       = 0,
			_str        = str.trim();

		// At least 8 characters, excluding white space
		if (_str.length < 8) {
			errors.push("password-8-characters");
		} else {
			score++;
		}

		// At least one Alphabetic character
		if ((/[a-zA-Z]+/).test(_str) === false) {
			errors.push("password-contain-letters");
		} else {
			score++;
		}

		// At least one CAPITAL letter
		if ((/[A-Z]+/).test(_str) === false) {
			errors.push("password-one-capital-letter");
		} else {
			score++;
		}

		// At least one lowercase Letter
		if ((/[a-z]+/).test(_str) === false) {
			errors.push("password-one-lowercase-letter");
		} else {
			score++;
		}

		// At least one Number
		if ((/[0-9]+/).test(_str) === false) {
			errors.push("password-one-number");
		} else {
			score++;
		}

		// At least one special character
		if ((/[\W]+/).test(_str) === false) {
			errors.push("password-one-special-char");
		} else {
			score++;
		}

		if (score >= 4 && score <= 5) {
			responseObj.strength = "Medium";
		} else if (score >= 6) {
			responseObj.strength = "Strong";
		}

		if ($('#changepassword-password_score').length > 0) {
			$('#changepassword-password_score').val(score);	
		}

		if ($('#customercreate-password_score').length > 0) {
			$('#customercreate-password_score').val(score);
		}

		responseObj.errors = errors;
		return responseObj;
	};

	$(document).ready(function documentReady()
	{
		if ($password_input.length > 0) {
			$password_input.on('keyup change', function click(e)
			{
				var checks = PasswordRequirements.testStrength($(this).val());
				PasswordRequirements.applyUi(checks);
			});
		}
	});

	HE.PasswordRequirements = PasswordRequirements;

}(jQuery, window.HE || {}));
